import { toFixed } from './index';
//px2rem
export const px2rem = (px: number): string => `${toFixed(px / 50, 3)}rem`;

export const remToPx = (rem: number) => {
  const { fontSize } = document.documentElement.style;
  return Math.floor(rem * +fontSize.replace('px', ''));
};
